import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell as TableCellOrig,
  TableHead as TableHeadOrig,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { tableHeadClass, tableCellClass, tableCellLastRowClass } from "@/components/ui/table-styles";
import PaginationButton from "@/components/ui/pagination-button";
import { PaymentMethod, PaymentType } from "@/gen/purchase_invoice/common_pb";
import { convertToCurrencyRounded } from "@/utils/currency_converter";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  DoubleArrowLeftIcon,
  DoubleArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@radix-ui/react-icons";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Route } from "..";
import { useRouter } from "@tanstack/react-router";
import { Checkbox } from "@/components/ui/checkbox";
dayjs.extend(customParseFormat);

const TableCell = ({ className = "", ...props }) => (
  <TableCellOrig className={[tableCellClass, className].join(" ")} {...props} />
);
const TableHead = ({ className = "", ...props }) => (
  <TableHeadOrig className={[tableHeadClass, className].join(" ")} {...props} />
);

const Screen = () => {
    const data = Route.useLoaderData()
    const search = Route.useSearch()
    const router = useRouter()

    return (
        <div>
        <div className="flex items-center justify-between">
            <Breadcrumb>
                <BreadcrumbList className="flex items-center">
                    <BreadcrumbItem>
                        <BreadcrumbLink onClick={() => {
                            router.navigate({
                                to: '/suppliers',
                            })
                        }} style={{
                            cursor: 'pointer'
                        }}>Suppliers</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbLink onClick={() => {
                            router.navigate({
                                to: '/suppliers/$supplierId',
                                params: {
                                    supplierId: data.supplier.supplier?.id || "",
                                },
                            })
                        }} style={{
                            cursor: 'pointer'
                        }}>
                        {data.supplier.supplier?.name}
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage>Credit Notes</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>
        </div>
        <hr className="my-4" />
        <div className="border rounded-lg bg-white overflow-hidden">
            <Table className="text-sm">
            <TableHeader>
                <TableRow className="">
                    <TableHead>Credit Note Number</TableHead>
                    <TableHead>Issue Date</TableHead>
                    <TableHead>Reason</TableHead>
                    <TableHead>Remaining Amount</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {data.creditNotes.creditNotes.map((item, index) => (
                <TableRow key={item.creditNoteId} className="font-medium">
                    <TableCell className={index === data.creditNotes.creditNotes.length - 1 ? tableCellLastRowClass : ""}>{item.creditNoteNumber}</TableCell>
                    <TableCell className={index === data.creditNotes.creditNotes.length - 1 ? tableCellLastRowClass : ""}>{dayjs(item.issuedAt?.toDate()).format("DD/MM/YYYY")}</TableCell>
                    <TableCell className={index === data.creditNotes.creditNotes.length - 1 ? tableCellLastRowClass : ""}>{item.notes}</TableCell>
                    <TableCell className={index === data.creditNotes.creditNotes.length - 1 ? tableCellLastRowClass : ""}>{convertToCurrencyRounded(item.totalAmount)}</TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
            <div className="flex items-center justify-between py-4 px-6 text-sm border-t bg-white">
                <p>{data.creditNotes.totalCount} <span className="text-gray-500 font-light">count</span></p>
                <div className="flex items-center gap-1">
                    <PaginationButton disabled onClick={() => {
                        router.navigate({
                            search: {
                                ...search,
                                page: 1,
                            },
                        });
                    }}>
                        <DoubleArrowLeftIcon className="h-4 w-4" />
                    </PaginationButton>
                    <PaginationButton disabled onClick={() => {
                        router.navigate({
                            search: {
                                ...search,
                                page: Math.max((search.page ? search.page : 1) - 1, 1),
                            },
                        });
                    }}>
                        <ChevronLeftIcon className="h-4 w-4" />
                    </PaginationButton>
                    {/* <PaginationButton active onClick={() => {}}>

                    </PaginationButton> */}
                    {Array.from({length: Math.ceil(data.creditNotes.totalCount/search.pageSize)}).map((_, index) => (
                        <PaginationButton
                            key={index}
                            active={search.page ? search.page === index + 1 : index === 0}
                            onClick={() => {
                                router.navigate({
                                    search: {
                                        ...search,
                                        page: index + 1,
                                    },
                                });
                            }}
                        >
                            {index + 1}
                        </PaginationButton>
                    ))}
                    <PaginationButton disabled onClick={() => {
                        router.navigate({
                            search: {
                                ...search,
                                page: Math.min((search.page ? search.page : 1) + 1, Math.ceil(data.creditNotes.totalCount/search.pageSize)),
                            },
                        });
                    }}>
                        <ChevronRightIcon className="h-4 w-4" />
                    </PaginationButton>
                    <PaginationButton disabled onClick={() => {
                        router.navigate({
                            search: {
                                ...search,
                                page: Math.ceil(data.creditNotes.totalCount/search.pageSize),
                            },
                        });
                    }}>
                        <DoubleArrowRightIcon className="h-4 w-4" />
                    </PaginationButton>
                </div>
            </div>
        </div>
        </div>
    );
};

export default Screen;